// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3oB-I","question":"Question_question__30eq0","description":"Question_description__2kDl0"};